import { Table } from 'antd'
import * as React from 'react'
import { Saldo } from '../../models/RaccoltaDatiModels'
import { ButtonEditInline } from '../shared/ButtonEditInline'
import { formatEuro } from '../shared/CurrencyFormat'

const { Column } = Table

interface TableSaldoCCProps {
    saldi: Array<Saldo>
    onSaldoEdit?: (record: Saldo) => void
}

export class TableSaldoCC extends React.Component<TableSaldoCCProps, any> {
    constructor(props) {
        super(props)
    }

    renderSaldo = (value: number, record: Saldo) => {
        if (this.props.onSaldoEdit == null)
            return <>{formatEuro(value)}</>

        return (
            <ButtonEditInline
                title="Clicca per modificare il valore"
                onClick={() => this.props.onSaldoEdit(record)}>&nbsp;{formatEuro(value)}</ButtonEditInline>
        )

    }

    render() {
        return (
            <>
                <h3>Saldo conti correnti</h3>
                <Table
                    dataSource={this.props.saldi}
                    rowKey={it => it.Id}
                    pagination={false}>
                    <Column title="Conto Corrente" dataIndex="ContoCorrente" ellipsis={true} />
                    <Column title="Saldo" dataIndex="Saldo" ellipsis={true} render={(value: number, record: Saldo) => this.renderSaldo(value, record)} />
                </Table>
            </>
        )
    }
}